/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Pool_Size_Contract_SubInputs */



/**
* | output |
* | --- |
* | "Prepaid in your contract" |
*
* @param {Usage_Tab_Pool_Size_Contract_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_pool_size_contract_sub = /** @type {((inputs?: Usage_Tab_Pool_Size_Contract_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Pool_Size_Contract_SubInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Vertrag vorausbezahlt")
	return /** @type {LocalizedString} */ ("Prepaid in your contract")
});